import ContactList from "../components/ContactList";

const ListContactPage = () => {
  return (
    <ContactList />
  );
};

export default ListContactPage;
